import React, { useEffect, useState } from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Images from '../Images';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaArrowAltCircleLeft } from "react-icons/fa";

function Vacfinal() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);
const navigate = useNavigate()
     const location = useLocation();
  const data = location.state;
    console.log("Vacfinal ~ data:", data.investmentType)
    return (
        <div>
            <div>
                <Header />
                <div className='inner_page position-relative pb-5'>
                    <img src={Images.elogo} className='elogo' alt="elogo" />
                    <img src={Images.smallround} className='smallround_footer' alt='round'/>
                    <Container className='mt-5'>
                          <button className='themebtn themehoverbtn rounded-1 widthunset mb-3 px-3 fw-600' onClick={()=>navigate(-1)}><FaArrowAltCircleLeft/> Back</button>
                        
                        <div className='vac_border position-relative vac_system rounded-3 py-5 px-4'>
                        <img src={Images.a1logo} className='a1logo' alt='round'/>
                        <img src={Images.a2logo} className='a2logo' alt="elogo" />
                        <img src={Images.a2logo} className='a3logo' alt="elogo" />
                            <Row>
                                <Col xl={8} xxl={10} className='mx-auto position-relative'>
                                <img src={Images.smallround} className='bot_round' alt='round'/>
                                <img src={Images.smallround} className='top_round' alt='round'/>
                                    <div className='vac_border rounded-3 py-5 px-4'>
                                        <h4 className='text-center fw-600 pb-3'>The VAC system will then interpret the score as follows</h4>

<div className='vac_border rounded-2 d-flex align-items-center justify-content-between py-3 px-3 mb-4'>
 <div>
    <h5>SOC Scorecard Interpretation of Bitcoin (BTC):</h5>
    <p className={`investmentclr mb-0 ${data.investmentType.replaceAll(" ","").toLocaleLowerCase()}`}>{data.investmentType}</p>
 </div>
 <Link  to="/scorecardanalysis"><button className='themebtn themehoverbtn rounded-1 py-3 fw-600'>See SOC Scorecard Analysis</button></Link>
</div>

                                        <div className='pb-3'>
                                            <h5 className='fw-600'>Final Decision</h5>
                                            <p className='mb-2'>Bitcoin (BTC) score: 2 points (13.33%) </p>
                                            <p className='mb-2'>BTC has 13.337% profitability within 4 years of this analysis.  </p>
                                            <p>Therefore, BTC is a <span className={`investmentclr ${data.investmentType.replaceAll(" ","").toLocaleLowerCase()}`}>{data.investmentType}.</span> </p>
                                        </div>
                                   {data.investmentType === "Bad Investment" ?
                                     <></> :
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                  <div className='vac_border rounded-2  py-3 px-3 mb-4'>
                                                      <p className='fw-600'>For more information on Ethereum (ETH),check it now at:</p> 
                                                       <button className='themebtn themehoverbtn widthunset rounded-1 py-3 px-3 fw-600'>EdaFace Listing Platform</button>
                                                  </div>
                                            </div>
                                            <div className='col-md-6'>
                                                  <div className='vac_border rounded-2  py-3 px-3 mb-4'>
                                                      <p className='fw-600'>Trade Ethereum today on:</p> 
                                                      <div className='d-flex gap-3 flex-wrap align-items-center '>
                                      <button className='themebtn themehoverbtn widthunset rounded-1 py-3 px-3 fw-600'>EdaFace Dex</button>
                                      <button className='themebtn themehoverbtn widthunset rounded-1 py-3 px-3 fw-600'>EdaFace P2P Market</button>
                                                      </div>
                                                       
                                                  </div>
                                            </div>
                                        </div>}
                                        
                                      <div className='vac_border rounded-2  py-3 px-3 mb-4'>
 <div>
    <p className='fw-500'>Are you the Project Owner or Representative, your Crypto Project cannot be listed on the EdaFace Listing Platform.</p>
    <p className='mb-0 fw-500'>Find out how to improve your Project SOC Score by clicking here:</p>
 </div>
 <button className='themebtn themehoverbtn rounded-1 mt-3 py-3 fw-600'>Improve your SOC Score</button>
</div>

                                        <div className='pb-1'>
                                            <h5 className='fw-600'>Disclaimer:</h5>
                                            <p className='mb-0'>Please, note that this is not investment advice, financial advice, trading advice, or any other sort of advice. Always Do Your Own research (DYOR)
before buying any digital asset. See EdaFace Full Disclaimer here:</p>
                                            </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </Container>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Vacfinal;

